// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type CashRegisterTypeFragmentFragment = { __typename?: 'CashRegisterTypeDTO', type: Types.CashRegisterTypeEnumDto | null, paperSize: Types.CashRegisterPaperSizeEnumDto | null, manufacturer: Types.CashRegisterManufacturerEnumDto | null };

export const CashRegisterTypeFragmentFragment = gql`
    fragment CashRegisterTypeFragment on CashRegisterTypeDTO {
  type
  paperSize
  manufacturer
}
    `;
/* eslint-enable */